// extracted by mini-css-extract-plugin
export default {"container":"AcceptInvitation_container__T5VHN","details":"AcceptInvitation_details__HYjKe","description":"AcceptInvitation_description__TR8MB"};